module.exports = __webpack_public_path__ + "icon_edit_gray.46b7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_edit_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_edit_gray.svg
// module chunks = main